/**
 * Qué tan viejo está el catálogo de una tienda de Prixia (L3, vault 276, PD-08). Lo usan
 * la tarjeta de la tienda en Competidores (empresa) y la lista de tiendas del panel de
 * plataforma, con la misma regla.
 *
 * D7: el aviso sale al DOBLE del intervalo del barrido programado (semanal → 14 días): un
 * barrido que falló una vez todavía no alarma; dos seguidos, sí. Con el barrido apagado
 * —así nace una tienda nueva (S2, P15) y así quedaron las migradas—, a los 14 días.
 */

export type UnidadDeIntervalo = 'HOURS' | 'DAYS' | 'WEEKS';

export const CATALOGO_VIEJO_SIN_PROGRAMA_DIAS = 14;

export interface FrescuraDelCatalogo {
  estado: 'al-dia' | 'vieja' | 'sin-barrido';
  /** null = todavía no hay ningún barrido completo. */
  diasDesdeBarrido: number | null;
  limiteDias: number;
}

export function intervaloEnDias(p: {
  intervalValue: number;
  intervalUnit: UnidadDeIntervalo;
}): number {
  if (p.intervalUnit === 'WEEKS') return p.intervalValue * 7;
  if (p.intervalUnit === 'DAYS') return p.intervalValue;
  return p.intervalValue / 24;
}

export function estadoDelCatalogo(p: {
  ultimoBarridoEn: string | null | undefined;
  barrido:
    | { intervalValue: number; intervalUnit: UnidadDeIntervalo; isActive: boolean }
    | null
    | undefined;
  ahora?: Date;
}): FrescuraDelCatalogo {
  const ahora = p.ahora ?? new Date();
  const limiteDias = p.barrido?.isActive
    ? Math.max(1, Math.ceil(intervaloEnDias(p.barrido) * 2))
    : CATALOGO_VIEJO_SIN_PROGRAMA_DIAS;
  const desde = p.ultimoBarridoEn ? new Date(p.ultimoBarridoEn).getTime() : NaN;
  if (Number.isNaN(desde)) return { estado: 'sin-barrido', diasDesdeBarrido: null, limiteDias };
  const dias = Math.floor((ahora.getTime() - desde) / 86_400_000);
  return { estado: dias >= limiteDias ? 'vieja' : 'al-dia', diasDesdeBarrido: dias, limiteDias };
}

/** La frase del aviso, o null si no hay nada que avisar. */
export function avisoDelCatalogo(f: FrescuraDelCatalogo, barridoEncendido: boolean): string | null {
  if (f.estado !== 'vieja' || f.diasDesdeBarrido == null) return null;
  const dias = f.diasDesdeBarrido === 1 ? '1 día' : `${f.diasDesdeBarrido} días`;
  const base = `El catálogo tiene ${dias}: los productos nuevos de la tienda no entran hasta el próximo barrido.`;
  return barridoEncendido ? base : `${base} El barrido programado está apagado.`;
}
